import canvasLmsLogo from "../app/assets/img/canvas-lms.svg";

const CanvasIcon = ({ size = 16 }) => (
  <img
    src={canvasLmsLogo}
    alt=""
    aria-hidden="true"
    style={{
      width: size,
      height: size,
      display: "block",
      objectFit: "contain",
    }}
  />
);

export default CanvasIcon;
